module.exports = {"guitars":["aurellia-egotalker-ii","jackson-chris-broderick-pro-7","epiphone-les-paul-mkh","etherial-egotalker","bc-rich-stealth","esp-sv-acid-martin"]}


//////////////////
// WEBPACK FOOTER
// ./static/data/guitars.json
// module id = hWB2
// module chunks = 1